import {observer} from 'mobx-react';
import React from 'react';
import {MQOptionsStore} from '../stores/MQOptionsStore';
import {MQBehaviorSelector} from './MQBehaviorSelector';
import {MQLeftTypeSelector} from './MQLeftTypeSelector';

@observer
export class MQOptionsComponent extends React.Component<{ store: MQOptionsStore }> {
  render() {
    const store = this.props.store;
    const children = this.props.children;
    return (
      <div className="row" key="matching-question-options">
        <div className="form-group col">
          <label>Behavior</label>
          <MQBehaviorSelector value={store.behavior.value}
                              onChange={store.behavior.setValue}/>
        </div>
        <div className="form-group col">
          <label>Left side content</label>
          <MQLeftTypeSelector value={store.leftSide.value}
                              onChange={store.leftSide.setValue}/>
        </div>
        {
          children &&
          <div className="col-auto">
            {children}
          </div>
        }
      </div>);
  }
}
